import { API_ROUTE_ADMIN_PHONE_SMS_LOGS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { LogSmsPushOriginal } from './types'

const IS_NEW_BACKEND_API = true

export const getSMSLogsList = async () =>
  (await get<{ smsLogs: LogSmsPushOriginal[] }>(API_ROUTE_ADMIN_PHONE_SMS_LOGS, IS_NEW_BACKEND_API))
    .smsLogs
